import { Timeout } from './const';
import { openModal } from './utils';

// Добавляет прелоадер
window.loadingStart = (isFull, el) => {
    const loader = document.querySelector(`[data-loader]`);
    const loaderMin = document.querySelector(`[data-loader-min]`);

    if (!isFull) {
        if (!el || el === null && !loader) return;

        window.loadingEnd();
        el.classList.add(`loading`);
        el.appendChild(loaderMin);
    } else {
        const overlay = document.querySelector(`[data-overlay]`);
        document.body.classList.add(`loading`);
        overlay.classList.add(`is-viewed`);
        loader.classList.add(`loader--full`);

        setTimeout(() => {
            document.body.classList.add(`no-scroll`);
            document.body.classList.add(`loading-animation`);
            overlay.classList.add(`animation`);
        }, Timeout.SHORT_TIMEOUT);
    }
};

// Убирает прелоадер
window.loadingEnd = () => {
    const loader = document.querySelector(`[data-loader]`);
    const loaderMin = document.querySelector(`[data-loader-min]`);

    if (!document.body.classList.contains(`loading`)) {
        const el = document.querySelector(`.loading`);
        if (!el || el === null && !loaderMin) return;

        el.classList.remove(`loading`);
        el.removeChild(loaderMin);
        document.body.appendChild(loaderMin);
    } else {
        const overlay = document.querySelector(`[data-overlay]`);
        document.body.classList.remove(`loading-animation`);
        overlay.classList.remove(`animation`);

        setTimeout(() => {
            document.body.classList.remove(`no-scroll`);
            document.body.classList.remove(`loading`);
            overlay.classList.remove(`is-viewed`);
            loader.classList.remove(`loader--full`);
        }, Timeout.ANIMATION_TOGGLE);
    }
};

window.openModal = (src, { afterLoadCb, beforeClose, afterClose }) => openModal(src, { afterLoadCb, beforeClose, afterClose });
